import { simplifyEnum } from 'Helpers'

export type exportCSVColumnsType = {
  col: string
  included: boolean
  path?: string
  // Optional getter to compute/override the value instead of using the path
  getValue?: (row: any) => string | number | null | undefined
}
export const possibleColumns: Record<string, exportCSVColumnsType[]> = {
  orderlines: [
    { col: 'ID', included: true, path: 'id' },
    { col: 'Order Line Name', included: true, path: 'name' },
    { col: 'Campaign Name', included: true, path: 'campaign.name' },
    {
      col: 'Status',
      included: true,
      path: 'state',
      getValue: (row) => (row?.state ? simplifyEnum(2, row.state, true) : ''),
    },
    {
      col: 'Clicks',
      included: true,
      path: 'stats.totals.clicks',
    },
    {
      col: 'CTR',
      included: true,
      path: 'CTR',
      getValue: (row) => {
        const ctr = row?.calculatedStats?.ctr ?? 0
        return `${ctr.toFixed(2)}%`
      },
    },
    {
      col: 'Total Impressions',
      included: true,
      path: 'impressions',
      getValue: (row) => {
        const total = Number((row as any)?.impressions ?? 0)
        return Number.isFinite(total) ? total : 0
      },
    },
    {
      col: 'Served Impressions',
      included: true,
      path: 'stats.totals.imps',
      getValue: (row) => {
        const served = Number((row as any)?.stats?.totals?.imps ?? 0)
        return Number.isFinite(served) ? served : 0
      },
    },
    {
      col: 'Budget',
      included: true,
      path: 'budget',
      getValue: (row) => {
        const served = Number(row?.calculatedStats?.budgetServed ?? 0)
        const total = Number(row?.calculatedStats?.budgetTotal ?? 0)
        const servedDisplay = served < total ? served : total
        const fmt = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        const servedText = Number.isFinite(servedDisplay)
          ? fmt.format(servedDisplay)
          : '-'
        const totalText = Number.isFinite(total) ? fmt.format(total) : '-'
        return `${servedText} / ${totalText}`
      },
    },
  ],
  campaigns: [
    { col: 'ID', included: true, path: 'id' },
    { col: 'Campaign Name', included: true, path: 'name' },
    {
      col: 'Status',
      included: true,
      path: 'status',
      getValue: (row) => (row?.status ? simplifyEnum(2, row.status, true) : ''),
    },
    {
      col: 'Clicks',
      included: true,
      path: 'calculatedStats.clicks',
    },
    {
      col: 'CTR',
      included: true,
      path: 'CTR',
      getValue: (row) => {
        const ctr = row?.calculatedStats.ctr ?? 0
        return `${ctr.toFixed(2)}%`
      },
    },
    {
      col: 'Total Impressions',
      included: true,
      path: 'calculatedStats.impressions',
      getValue: (row) => {
        const total = Number(row?.calculatedStats?.impressions ?? 0)
        return Number.isFinite(total) ? total : 0
      },
    },
    {
      col: 'Served Impressions',
      included: true,
      path: 'stats.totals.imps',
      getValue: (row) => {
        const served = Number((row as any)?.stats?.totals?.imps ?? 0)
        return Number.isFinite(served) ? served : 0
      },
    },
    {
      col: 'Budget',
      included: true,
      path: 'budget',
      getValue: (row) => {
        const served = Number(row?.calculatedStats?.budgetServed ?? 0)
        const total = Number(row?.calculatedStats?.budgetTotal ?? 0)
        const servedDisplay = served < total ? served : total
        const fmt = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        const servedText = Number.isFinite(servedDisplay)
          ? fmt.format(servedDisplay)
          : '-'
        const totalText = Number.isFinite(total) ? fmt.format(total) : '-'
        return `${servedText} / ${totalText}`
      },
    },
  ],
  orderLinesWChild: [
    { col: 'ID', included: true, path: 'id' },
    { col: 'Order Line Name', included: true, path: 'name' },
    { col: 'Campaign Name', included: true, path: 'campaign.name' },
    { col: 'Organization', included: true, path: 'orgName' },
    {
      col: 'Status',
      included: true,
      path: 'state',
      getValue: (row) => (row?.state ? simplifyEnum(2, row.state, true) : ''),
    },
    {
      col: 'Clicks',
      included: true,
      path: 'stats.totals.clicks',
    },
    {
      col: 'CTR',
      included: true,
      path: 'CTR',
      getValue: (row) => {
        const ctr = row?.calculatedStats?.ctr ?? 0
        return `${ctr.toFixed(2)}%`
      },
    },
    {
      col: 'Total Impressions',
      included: true,
      path: 'impressions',
      getValue: (row) => {
        const total = Number((row as any)?.impressions ?? 0)
        return Number.isFinite(total) ? total : 0
      },
    },
    {
      col: 'Served Impressions',
      included: true,
      path: 'stats.totals.imps',
      getValue: (row) => {
        const served = Number((row as any)?.stats?.totals?.imps ?? 0)
        return Number.isFinite(served) ? served : 0
      },
    },
    {
      col: 'Budget',
      included: true,
      path: 'budget',
      getValue: (row) => {
        const served = Number(row?.calculatedStats?.budgetServed ?? 0)
        const total = Number(row?.calculatedStats?.budgetTotal ?? 0)
        const servedDisplay = served < total ? served : total
        const fmt = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        const servedText = Number.isFinite(servedDisplay)
          ? fmt.format(servedDisplay)
          : '-'
        const totalText = Number.isFinite(total) ? fmt.format(total) : '-'
        return `${servedText} / ${totalText}`
      },
    },
  ],
  campaignsWChild: [
    { col: 'ID', included: true, path: 'id' },
    { col: 'Campaign Name', included: true, path: 'name' },
    { col: 'Organization', included: true, path: 'orgName' },
    {
      col: 'Status',
      included: true,
      path: 'state',
      getValue: (row) => (row?.status ? simplifyEnum(2, row.status, true) : ''),
    },
    {
      col: 'Clicks',
      included: true,
      path: 'calculatedStats.clicks',
    },
    {
      col: 'CTR',
      included: true,
      path: 'CTR',
      getValue: (row) => {
        const ctr = row?.calculatedStats?.ctr
        return `${ctr.toFixed(2)}%`
      },
    },
    {
      col: 'Total Impressions',
      included: true,
      path: 'calculatedStats.impressions',
      getValue: (row) => {
        const total = Number(row?.calculatedStats?.impressions ?? 0)
        return Number.isFinite(total) ? total : 0
      },
    },
    {
      col: 'Served Impressions',
      included: true,
      path: 'stats.totals.imps',
      getValue: (row) => {
        const served = Number((row as any)?.stats?.totals?.imps ?? 0)
        return Number.isFinite(served) ? served : 0
      },
    },
    {
      col: 'Budget',
      included: true,
      path: 'budget',
      getValue: (row) => {
        const served = Number(row?.calculatedStats?.budgetServed ?? 0)
        const total = Number(row?.calculatedStats?.budgetTotal ?? 0)
        const servedDisplay = served < total ? served : total
        const fmt = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        const servedText = Number.isFinite(servedDisplay)
          ? fmt.format(servedDisplay)
          : '-'
        const totalText = Number.isFinite(total) ? fmt.format(total) : '-'
        return `${servedText} / ${totalText}`
      },
    },
  ],
}
